<div class="game-wrapper" *ngIf="game_data != undefined">
  <h1>{{ game_data.name_de }}</h1>
  <div class="half-box">
    <img src="{{ game_data.image_url }}" alt="" />
  </div>
  <div class="half-box">
    <table>
      <tr>
        <td class="first">{{ i18n.game.release }}</td>
        <td class="second">{{ game_data.release }}</td>
      </tr>
      <tr>
        <td class="first">{{ i18n.game.engine }}</td>
        <td class="second">{{ game_data.engine }}</td>
      </tr>
      <tr>
        <td class="first">{{ i18n.game.platform }}</td>
        <td class="second">{{ game_data.platform }}</td>
      </tr>
      <tr>
        <td class="first">{{ i18n.game.genre }}</td>
        <td class="second">{{ game_data.genre }}</td>
      </tr>
      <tr>
        <td class="first">{{ i18n.game.playtime }}</td>
        <td class="second">{{ game_data.playtime }}</td>
      </tr>
      <tr>
        <td class="first">{{ i18n.game.language }}</td>
        <td *ngIf="game_data.lang === 'de'" class="second">
          {{ i18n.lang_de }}
        </td>
        <td *ngIf="game_data.lang === 'en'" class="second">
          {{ i18n.lang_en }}
        </td>
      </tr>
    </table>
    <div *ngIf="game_data.platform != 'browser'" class="download-area">
      <a href="{{ game_data.dl_url }}">
        <button>Download {{ game_data.version }}</button>
      </a>
    </div>
    <div *ngIf="game_data.platform == 'browser'" class="download-area">
      <a target="blank" href="{{ game_data.dl_url }}">
        <button>Play {{ game_data.version }}</button>
      </a>
    </div>
  </div>
  <div class="description-box">
    <h3>{{ i18n.game.descr }}</h3>
    <p *ngIf="current_lang === 'de'">
      {{ game_data.descr_de }}
    </p>
    <p *ngIf="current_lang === 'en'">{{ game_data.descr_en }}</p>
  </div>
  <div *ngIf="game_data.lps != undefined" class="description-box">
    <h3>{{ i18n.game.web }}</h3>
    <ul>
      <li *ngFor="let link of game_data.lps">
        <p class="link">
          <a target="_blank" href="{{ link.link }}">
            <img src="../../../assets/img/icons/015-youtube.svg" alt="" /> By
            {{ link.name }}</a
          >
        </p>
      </li>
    </ul>
    <br />
  </div>
</div>
